import _ from 'underscore'

const initialState = {
    progress: 0,
    active: false
}

const initializeState = () => Object.assign({}, initialState)

export default function progressBar(state = initializeState(), action = {}) {
    switch (action.type) {

    /*case IssuesActionTypes.IssuesRequest.post.TYPES.PROGRESS:
        return { ...state, active: true, percent: action.payload.percent || 0 }
    case IssuesActionTypes.IssuesRequest.post.TYPES.SUCCESS:
    case IssuesActionTypes.IssuesRequest.post.TYPES.FAILURE:
        return { ...state, active: false }*/

    default: 
        return state
    }
}


// WEBPACK FOOTER //
// ./src/client/features/progressBar/reducers.js